import * as fromReducers from './reducers';

import { ActivatedRouteSnapshot, Resolve } from '@angular/router';
import { Observable, of } from 'rxjs';
import { filter, switchMap, take, withLatestFrom } from 'rxjs/operators';

import { AppState } from '../reducers';
import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { Workspace } from './models/core.models'; // Assuming Workspace is a model like Feed

@Injectable({
  providedIn: 'root',
})
export class WorkspaceResolver implements Resolve<Workspace | null> {
  constructor(private store: Store<AppState>) {}

  resolve(route: ActivatedRouteSnapshot): Observable<Workspace | null> {
    const workspaceId = route.paramMap.get('workspaceId');
    if (!workspaceId) {
      return of(null); // or throw an error, or navigate away
    }

    return this.getWorkspaceObject(workspaceId);
  }

  private getWorkspaceObject(
    workspaceId: string,
  ): Observable<Workspace | null> {
    // First, wait for the flag to be true
    return this.store.select(fromReducers.selectCoreWorkspacesLoaded).pipe(
      filter((loaded) => loaded === true),
      take(1), // Take only the first instance where the flag is true.
      withLatestFrom(
        this.store.select(
          fromReducers.selectWorkspaceByWorkspaceId(workspaceId),
        ),
      ),
      switchMap(([_, workspace]) => {
        if (workspace) {
          // If the workspace data is already loaded, return it.
          return of(workspace);
        }
        return of(null);
      }),
    );
  }
}
